import { render } from "./HobbiesPage.vue?vue&type=template&id=0a6bccc8&scoped=true"
import script from "./HobbiesPage.vue?vue&type=script&lang=js"
export * from "./HobbiesPage.vue?vue&type=script&lang=js"

import "./HobbiesPage.vue?vue&type=style&index=0&id=0a6bccc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6bccc8"]])

export default __exports__